export default "__VITE_ASSET__23dd6871__"